module.exports = __webpack_public_path__ + "img/redim.d41f3e82.png";